import { z } from 'zod'

export const processEmbedded = z.preprocess(
  val => `${val}`,
  z.enum(['native', 'web', 'true']).optional().catch(undefined)
)
